// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import HelpTextEntity from 'granite-admin/common/entities/helpText';
async function getHelpText(params) {
  const payload = {
    params: {
      ...params,
      page_size: 499
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get(`/help-text/`, payload);
    const helpText = data.results.length ? data.results.map(item => new HelpTextEntity(item)) : [];
    return helpText;
  } catch (error) {
    // console.log(error);
    return [];
  }
}
async function createHelpText(payload) {
  try {
    const {
      pk,
      ...rest
    } = payload;
    let resp = {};
    if (pk) resp = await GraniteAPIClient().put(`/help-text/${pk}/`, payload);else resp = await GraniteAPIClient().post('/help-text/', rest);
    return new HelpTextEntity(resp?.data);
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteHelpText(pk) {
  try {
    await GraniteAPIClient().delete(`/help-text/${pk}/`);
  } catch (error) {
    throw new GraniteError(error);
  }
}
export default {
  getHelpText,
  createHelpText,
  deleteHelpText
};